(function () {
    var controllerId = 'revenue.views.subscriptions.detail.index';
    var module = angular.module('revenue');

    module.controller(controllerId, function () {
        // EMPTY
    });
})();